export default __webpack_public_path__ + "static/media/calendar.2838afb9.svg";